export default {
    HIGH_TAG: "HIGH_TAG",
    LOW_TAG: "LOW_TAG",
    DUAL: "DUAL"
};
